import React, { Suspense, useState, useEffect } from 'react';
import { Routes, Route } from 'react-router';
import Dashboard from './Dashboard';
import Box from '@mui/material/Box';
import WebFont from 'webfontloader';
import LoadingOverlay from '../loadingOverlay/LoadingOverlay';
import useApi from '../hooks/useApi';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Page from './Page';
import Email from './Email';
import useSuspenseFetch from '../hooks/useSuspenseFetch';
import SplashScreen from '../splashScreen/SplashScreen';

const ReportsInner = () => {
    const { handleGet } = useApi();
    const [fonts, setFonts] = useState(null);
    const { data: user } = useSuspenseFetch('user');

    const hasManageReportsPermission = user.permissions.includes('Manage Reports');

    const handleFetchCustomFonts = async () => {
        const response = await handleGet('fonts');

        if (!response.ok) {
            return;
        }

        const data = await response.json();
        setFonts(data);
    };

    const handleLoadFonts = font => {
        if (font.type === 'google') {
            WebFont.load({
                google: {
                    families: [font.name]
                }
            });
        }
    };

    useEffect(() => {
        (fonts && fonts.length > 0) && fonts.forEach((font) => handleLoadFonts(font));
    }, [fonts]);

    useEffect(() => {
        if (hasManageReportsPermission) {
            handleFetchCustomFonts();
        }
    }, []);

    if (!hasManageReportsPermission) {
        return (
            <Paper sx={{ padding: 6, textAlign: 'center' }}>
                <Typography>You don't have permission to manage Reports.</Typography>
                <Typography>Please contact your account administrator to have this enabled.</Typography>
            </Paper>
        );
    }

    if (!fonts) {
        return <LoadingOverlay />;
    }

    return (
        <Routes>
            <Route path="/" element={(
                <Box>
                    <Dashboard />
                </Box>
            )} />
            <Route path="email/:id" element={<Email />} />
            <Route path="page/:id" element={<Page />} />
        </Routes>
    );
};

// todo the following is needed because React Router 7 requires each route to have its own Suspense boundary
// see https://github.com/remix-run/react-router/issues/10568
// inner component can be avoided by only loading resources where they are needed instead of drilling them like this

const Reports = () => {
    return (
        <Suspense fallback={<SplashScreen />}>
            <ReportsInner />
        </Suspense>
    );
};

export default Reports;